import React, { Component } from "react";
import { Link } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';

export default class ListaCursosVirtual extends Component {
  render() {
    const debts = this.props.objCursos;
    return (
      <div className="card-Curso text-card">
        <div
          className={
            debts.courseType == "Presencial"
              ? "border-presencial card-apagar-head-Curso"
              : "border-virtual card-apagar-head-Curso"
          }
          key={debts.courseId}
          style={{ alignItems: "baseline" }}
        >
          <div
            className="columna-0 justify-content-between"
            style={{
              textAlign: "left",
              top: "-55%",
              position: "relative",
            }}
          >
            <h1 className="nombre-curso">
              {debts.courseName} ({debts.courseSection})
            </h1>
            <h1 className="nombre-profesor">
              Profesor:{" "}
              {debts.professorArray.map((profesor, i) => {
                return profesor.typeDescription == "Titular"
                  ? profesor.professorName
                  : null;
              })}
            </h1>
            <h1 className="estado">Estado: {debts.courseState}</h1>
          </div>
          <div className="columna-2">
            <h1 className="carrera-estudiante" style={{ fontSize: "0.9rem" }}>
              {debts.attendance_fail_amount} de {debts.attendance_max}
            </h1>
          </div>
          <div className="columna-3">
            {" "}
            <h1 className="carrera-estudiante" style={{ fontSize: "0.9rem" }}>
              {debts.credits}
            </h1>
          </div>
          <div className="columna-4">
            <h1 className="carrera-estudiante" style={{ fontSize: "0.9rem" }}>
              {debts.cicle}
            </h1>
          </div>
          <div className="columna-5">
            <h1 className="carrera-estudiante" style={{ fontSize: "0.9rem" }}>
              {debts.grades_amount}
            </h1>
          </div>
          <div className="columna-6">
            <h2 className="carrera-estudiante" style={{ fontSize: "0.7rem" }}>
              {debts.courseType == "Presencial" ? "PRESENCIAL" : "VIRTUAL"}
            </h2>
          </div>
          <div className="columna-7">
            <h1 className="carrera-estudiante" style={{ fontSize: "0.9rem" }}>
              {debts.finalGrade}
            </h1>
          </div>

          <div className="columna-8">
            <Link
              to={`/detalle-curso/${debts.courseId}/${debts.courseSection}/${debts.period}`}
            >
                <i class="bi bi-file-earmark-text-fill" style={{ color: "#FDBA30" , fontSize: 40}} 
                ></i> 
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
